module.exports = __webpack_public_path__ + "media/images/sp/special_reports/text_day3-c967397529b84877d1fbaf51de0d5a64.svg";